import presentations_data from '../data/presentations.json'

export function get_slide_decks(include_unpublished) {
    const data = presentations_data.presentations
    const status = 200
    if (include_unpublished === true) {
        return { status, data }
    }
    const filtered_data = data.filter((x) => x.is_published);
    return { status, 'data': filtered_data }

}

